/**
 * Gemeinsamer Adress-Formatierungs-Helfer für Client und Server.
 * Verhindert die doppelte Hausnummer, wenn die Hausnummer bereits im
 * street-Feld enthalten ist (häufig bei importierten Daten,
 * z.B. street="Ackerweg 8", houseNumber="8").
 * Spiegelt exakt die Heuristik aus renderAddress (TableColumnRenderers.tsx).
 */

/**
 * Kombiniert Straße und Hausnummer. Enthält die Straße bereits eine
 * Hausnummer (Buchstaben gefolgt von einer Ziffer), wird nur die Straße
 * zurückgegeben — sonst werden Straße und Hausnummer mit Leerzeichen verbunden.
 */
export const formatStreetWithHouseNumber = (street?: string | null, houseNumber?: string | null): string => {
    const parts = [street, houseNumber].filter((part): part is string => Boolean(part && part.trim() !== ""));

    if (street && /([A-Za-z])+.+\d/.test(street)) {
        return street;
    }

    return parts.join(" ");
};

/**
 * Baut eine einzeilige Adresse: "<Straße Hausnr.>, <PLZ Ort>".
 * Leere Bestandteile werden ausgelassen.
 */
export const formatBookerAddressOneLine = (street?: string | null, houseNumber?: string | null, postCode?: string | null, city?: string | null): string => {
    const streetLine = formatStreetWithHouseNumber(street, houseNumber);
    const cityLine = [postCode, city].filter((part): part is string => Boolean(part && part.trim() !== "")).join(" ");

    return [streetLine, cityLine].filter((part) => part !== "").join(", ");
};
